<script setup lang="ts">
import burgerMenuIcon from '@/assets/img/nav/hamburger-menu.svg';
import { AppAvatar, AppButton, AppLogoBanner } from '@/components';
import { useAuthStore } from '@/modules/auth/store/auth';
import { storeToRefs } from 'pinia';

const { user } = storeToRefs(useAuthStore());

const emits = defineEmits<{
  (e: 'openDrawer'): void;
}>();

interface Props {
  showBurgerMenu: boolean;
}
const { showBurgerMenu = false } = defineProps<Props>();
</script>

<template>
  <ClientOnly>
    <div class="navbar-container">
      <v-app-bar :elevation="0" height="80" class="the-navbar">
        <div class="navbar-container d-flex justify-space-between">
          <v-app-bar-nav-icon width="231px" height="29px">
            <nuxt-link to="/">
              <AppLogoBanner width="251px" height="29px" />
            </nuxt-link>
          </v-app-bar-nav-icon>

          <div class="d-flex align-center" v-if="showBurgerMenu">
            <AppButton class="burger-menu" variant="text" @click="emits('openDrawer')">
              <v-img :src="burgerMenuIcon" width="24" height="24" class="cursor-pointer" />
            </AppButton>
            <AppAvatar class="border-ring" :src="getAvatar(user.first_name, user.avatar)" size="32" />
          </div>
        </div>
      </v-app-bar>
      <div class="rounded-corner"></div>
    </div>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.navbar-container {
  background: rgb(var(--v-theme-background-top-nav)) !important;
  align-items: center;
}

.burger-menu {
  padding-right: 0;
}

.rounded-corner {
  background-color: rgb(var(--v-theme-background-body));
  height: 40px;
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
}
:deep(.v-toolbar__content) {
  max-width: 1440px;
  margin: auto;
  padding: 24px;
  display: block;
}

.the-navbar {
  background: rgb(var(--v-theme-background-top-nav)) !important;

  .navbar-container {
    max-width: 850px;
    margin: auto;
  }

  .v-btn--icon {
    margin-inline-start: 0 !important;
    margin-inline-end: 0 !important;
  }

  &__profile {
  }

  &__mobile {
    display: none;
  }

  &__menu {
  }

  &__mobile-menu {
    display: none;
    position: fixed;
    // @NOTE: Header height
    top: 72px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .v-list {
      height: 100%;
    }
  }
}

@media (max-width: 768px) {
  .the-navbar {
    // border-bottom: 1px solid whitesmoke;

    &__profile {
      display: none;
    }

    &__mobile {
      display: block;
    }

    &__mobile-menu {
      display: block;
    }
  }
}
</style>
